"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const ui_1 = require("@ocean-club/ui");
const schemas_1 = require("@ocean-club/schemas");
const eth_1 = require("../../lib/eth");
const utils_1 = require("../../modules/translation/utils");
const Modal_1 = __importDefault(require("../../containers/Modal"));
class Navbar extends React.PureComponent {
    constructor() {
        super(...arguments);
        this.getTranslations = () => {
            if (!this.props.hasTranslations) {
                return undefined;
            }
            return {
                menu: {
                    marketplace: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.marketplace" }),
                    events: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.events" }),
                    agora: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.agora" }),
                    dao: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.dao" }),
                    docs: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.docs" }),
                    blog: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.blog" }),
                    builder: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.builder" }),
                    about: React.createElement(utils_1.T, { id: "@dapps.navbar.menu.about" })
                },
                account: {
                    connecting: React.createElement(utils_1.T, { id: "@dapps.navbar.account.connecting" }),
                    signIn: React.createElement(utils_1.T, { id: "@dapps.navbar.account.signIn" })
                }
            };
        };
        this.getModalTranslations = () => {
            if (!this.props.hasTranslations) {
                return undefined;
            }
            return {
                wrongNetwork: {
                    header: React.createElement(utils_1.T, { id: "@dapps.navbar.wrongNetwork.header" }),
                    message: (React.createElement(utils_1.T, { id: "@dapps.navbar.wrongNetwork.message", values: { currentChainName: '', expectedChainName: '' } }))
                }
            };
        };
    }
    isValidChainId(currentChainId, expectedChainId) {
        return !!expectedChainId && currentChainId !== expectedChainId;
    }
    render() {
        const { chainId } = this.props;
        const expectedChainId = eth_1.getConnectedProviderChainId();
        return (React.createElement(React.Fragment, null,
            React.createElement(ui_1.Navbar, Object.assign({}, this.props, { i18n: this.getTranslations() })),
            chainId && this.isValidChainId(chainId, expectedChainId) ? (React.createElement(Modal_1.default, { open: true, size: "tiny", i18n: this.getModalTranslations() },
                React.createElement(ui_1.ModalNavigation, { title: React.createElement(utils_1.T, { id: "@dapps.navbar.wrongNetwork.header" }) }),
                React.createElement(Modal_1.default.Content, null,
                    React.createElement(utils_1.T, { id: "@dapps.navbar.wrongNetwork.message", values: {
                            currentChainName: React.createElement("b", null, schemas_1.getChainName(chainId)),
                            expectedChainName: React.createElement("b", null, schemas_1.getChainName(expectedChainId))
                        } })))) : null));
    }
}
exports.default = Navbar;
//# sourceMappingURL=Navbar.js.map